"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conditionToText = exports.conditionToMjml = void 0;

var conditionToMjml = function conditionToMjml(item, blockRenderer, isTopLevelNode) {
  var ifItems = '';
  var elseItems = '';
  var ifChildBlockItems = item.children[0];
  var elseChildBlockItem = item.children[1];
  (ifChildBlockItems.children || []).forEach(function (x) {
    ifItems += blockRenderer(x, blockRenderer, isTopLevelNode);
  });
  (elseChildBlockItem.children || []).forEach(function (x) {
    elseItems += blockRenderer(x, blockRenderer, isTopLevelNode);
  });
  return '{{#if ' + item.properties.condition + '}}' + ifItems + '{{else}}' + elseItems + '{{/if}}';
};

exports.conditionToMjml = conditionToMjml;

var conditionToText = function conditionToText(item, blockRenderer, isTopLevelNode) {
  var ifItems = '';
  var elseItems = '';
  var ifChildBlockItems = item.children[0];
  var elseChildBlockItem = item.children[1];
  (ifChildBlockItems.children || []).forEach(function (x) {
    ifItems += blockRenderer(x, blockRenderer, isTopLevelNode);
  });
  (elseChildBlockItem.children || []).forEach(function (x) {
    elseItems += blockRenderer(x, blockRenderer, isTopLevelNode);
  });
  return '{{#if ' + item.properties.condition + '}}\r\n' + ifItems + '{{else}}' + elseItems + '{{/if}}\r\n' + '\r\n';
};

exports.conditionToText = conditionToText;